import { Box, withStyles } from '@material-ui/core';
import React from 'react';
import styles from './call-usage-banner.style';
import { InfoIcon, Typography } from '@orijinworks/frontend-commons';
import CallIcon from '@material-ui/icons/Call';
import useCallUsageBannerHook from './useCallUsageBannerHook';

const CallUsageBanner = ({ classes, learnerProfile }) => {
  const {
    maxCallDurationPerCall,
    maxCallDurationPerDay,
    consumedCallDurationPerDay,
    remainingCallDurationPerDay,
    isLoading,
    hasValidData,
  } = useCallUsageBannerHook(learnerProfile?.learnerId);

  if (isLoading || !hasValidData) {
    return null; // Hide banner when loading or when data is invalid/missing
  }

  return (
    <Box className={classes.root} display={'flex'} flexDirection={'row'} data-testid="call-usage-banner">
      <CallIcon data-testid="call-icon" />
      <Box display={'flex'} flexDirection={'column'} className={classes.gap} data-testid="content-container">
        <Typography variant="h2" data-testid="remaining-time" className={classes.timeRemainingText}>
          {learnerProfile?.learnerName} has <span className={classes.timeLimitRemaining} data-testid="remaining-time-value">{remainingCallDurationPerDay}</span> of voice call time remaining today.
        </Typography>
        <Typography variant="body1" data-testid="consume-time">
          They have used <b data-testid="consumed-time-value">{parseInt(consumedCallDurationPerDay)}</b> of <b data-testid="max-daily-time-value">{maxCallDurationPerDay}</b> minutes available.
        </Typography>
        <Box display={'flex'} flexDirection={'row'} alignItems={'flex-start'} data-testid="info-container">
          <InfoIcon data-testid="info-icon" />
          &nbsp;
          <Typography variant="body1" data-testid="max-call-duration">
            No individual call may last longer than <span data-testid="max-call-duration-value">{maxCallDurationPerCall}</span> minutes.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default withStyles(styles)(CallUsageBanner);
